import { notification } from 'antd'
import { useMutation } from 'react-query'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'

import { QUERY_KEYS } from '@api'

import { getContractsByCarrierId } from './api'
import { GetContractsByCarrierResponse } from '../../types'

const useGetContractsByCarrier = () => {
  const { t } = useTranslation()
  const onError = () => {
    notification.error({
      message: t('TODO: Error message'),
    })
  }
  const onEmptyResult = useCallback(() => {
    notification.error({
      message: t('globals.no_simulation_results'),
    })
  }, [t])

  const isResponseEmpty = (
    contracts: GetContractsByCarrierResponse['contracts'] | undefined,
  ): boolean => {
    return !contracts || contracts.length === 0
  }
  const { data, mutate, isLoading, reset } = useMutation(
    [QUERY_KEYS.CONTRACTS_BY_CARRIER],
    getContractsByCarrierId,
    {
      onError,
      onSuccess: res => {
        if (isResponseEmpty(res)) {
          onEmptyResult()
        }
      },
    },
  )

  return {
    contractsByCarrier: data,
    getContractsByCarrier: mutate,
    resetContractsByCarrier: reset,
    getContractsByCarrierIsLoading: isLoading,
  }
}

export { useGetContractsByCarrier }
